module.exports = __webpack_public_path__ + "img/3.21ea98d7.svg";